import React, {Component} from 'react';
import {reverseParseTextView} from './createRender';
import { Rate,Tabs,Button,Tooltip} from 'antd';

import * as Types from './../../../utils/questionType';

import {view as QuestionView} from '../question_view';
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';

const {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP}= Types

const {TabPane} = Tabs;
const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Question extends Component {
    state = {
        hideSub: true,
        originData:false,
        iusInit:false,
        visible: false
    }
    toggleAnswer = (val, e) => {
        // val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
        e.stopPropagation();
        this.setState({visible: val});
    };
    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            })
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    }


    componentDidUpdate(prevProps, prevState) {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });

        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    }
    createHtml = str => ({__html: str ? str : `&nbsp;`});

    onExpand = (val) => {//展开
        let hideSub = val
        this.setState({hideSub})

    };

    render() {
        const {visible} = this.state;
        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

        if(!originData) return null
        const {num, children} = this.props;
        const childExerciseMap = {}; //子题对象。key：题号，value：题目详情。

        //题目字段转换
        !!originData.sub_list.length && originData.sub_list.map(item => {
            //子题对象。key：题号，value：题目详情。
            childExerciseMap[item.number] = item;

            return item;
        });
        if(this.state.originData != 'bad'&&originData.sub_list&&originData.sub_list.length){
            originData.sub_list.forEach((d,i)=>{
                originData.sub_list[i].number = (i+1)+''
            })
            if(originData.answer==='[]'){
                this.state.originData = 'bad'
            }else{
                this.state.originData = reverseParseTextView(originData)
            }
            this.state.isInit = true;
        }
        let data =this.state.originData;
        if(!data) {return null}


        //答案和字体列表不对应 标为坏题
        const loop = (arr)=>{
            arr.forEach((d,k)=>{
                if(d==='bad'){
                    this.state.originData = 'bad'
                    data = 'bad'
                }
                if(d.children&&d.children.length){
                    loop(d.children)
                }
            })
        }
        let treeData = []
        if(data.answer){
            treeData = data.answer
            loop(treeData)
        }

        const childHtml = (exercise) => {
            if(!exercise){return null}
            return <div key={exercise.number}>
                {
                    exercise.stage !== exercise.parentStage &&
                    <p className="stage-tag">{Types.QUESTIONSTAGE[exercise.stage]}</p>
                }
                {
                    exercise.stage === exercise.parentStage &&
                    <p className="stage-tag-small">{Types.QUESTIONSTAGE[exercise.stage]}</p>
                }
                {
                    <QuestionView data={exercise} index={num}  num={parseInt(exercise.number) - 1}/>
                }
            </div>;
        };

        const renderChildNode = (node) => {
            if (!!node.children.length) {
                if (node.branch) {
                    return <div>
                        {childHtml(childExerciseMap[node.index])}
                        <div style={{padding: 30}}>
                            <Tabs>
                                {
                                    node.children.map((n, i) =>
                                        <TabPane key={node.option[i]} tab={node.option[i]}>
                                            {renderChildNode(n)}
                                        </TabPane>
                                    )
                                }
                            </Tabs>
                        </div>
                    </div>
                }
                return <div>
                    {childHtml(childExerciseMap[node.index])}
                    {renderChildNode(node.children[0])}
                </div>;
            } else {
                return childHtml(childExerciseMap[node.index]);
            }
        };
        if(this.state.originData === 'bad'){
            return <div className="box-exercise" ref="viewer">
                <div className="exercise-content" style={{ borderBottom: '1px solid #eaedf6'}}>
                    <p style={{fontSize:'26px',textAlign:'center',marginTop:'20px'}}>此题格式错误，无法解析</p>
                </div>
            </div>
        }

        return (
            <div className="box-exercise" ref="viewer">
                <div className="exercise-content" style={{marginBottom: 20, borderBottom: '1px solid #eaedf6'}}>
                    <Button style={{position:'absolute',top:'10px',right:'10px',opacity:'0.5'}} type={'primary'} onClick={() => {this.onExpand(!this.state.hideSub)}}>{this.state.hideSub?'隐藏子题':'显示子题'}</Button>

                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    <div className="exercise-con" style={{width: 'calc(100% - 150px)',margin: '6px 0',fontSize: '18px',lineHeight:'24px'}} dangerouslySetInnerHTML={this.createHtml(data.stem)}/>

                </div>
                <div className="exercise-footer">
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>


                        </Footer>
                    </div>
                </div>

 
                {
                    this.state.hideSub&&
                    <div style={{borderLeft: '2px solid #00b1fe', marginLeft: -1}}>
                        {   data.answer&&data.answer[0]&&
                        renderChildNode(data.answer[0])
                        }
                    </div>
                }
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/fillinblank/viewForView.js